import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ArrayHelpers, Picker, SystemText } from '@salesperformanceint/e4shared';
import { load, add, update, remove } from 'actions/admin';
import { setShowSuccess } from 'actions/ui';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';
import SortAreas from './components/sortAreas';
import SortCompetencies from '../competencies/components/sortCompetencies';

export const AdminCompetencyAreas = ({ ...props }) => {
    const dispatch = useDispatch();

    const [showSort, setShowSort] = useState(false);
    const [showCompSort, setShowCompSort] = useState(false);
    const [compSortArea, setCompSortArea] = useState(null);
    const [pickerItem, setPickerItem] = useState();
    const [showPicker, setShowPicker] = useState();

    const data = useSelector(state => state.admin.competencyAreas);
    const competencies = useSelector(state => state.admin.competencies);

    const loadCompetencies = () => {
        dispatch(load('competency'));
    };
    const onLoad = () => {
        dispatch(load('competency-area'));
    };

    const onAdd = (entity, callback) => {
        dispatch(add('competency-area', entity, null, callback));
    };

    const onUpdate = (entity, callback) => {
        dispatch(update('competency-area', entity, null, callback));
    };

    const onRemove = (ids, callback) => {
        if (!Array.isArray(ids)) ids = [ids];
        ids.forEach((id, idx) => {
            dispatch(remove('competency-area', id, () => idx + 1 === ids.length && callback()));
        });
    };

    useEffect(() => {
        onLoad();
        loadCompetencies();
    }, []);

    const options = {
        ...DefaultOptions(),
        sortBy: 'sequence',
        label: SystemText('Admin/CompetencyAreas/Options/Label'),
        labelPlural: SystemText('Admin/CompetencyAreas/Options/Label/Plural'),
        mainColumnIndex: 1,
        extraOptions: [
            {
                btnClass: 'btn-primary',
                disabled: d => d.competency_Ids.length <= 1,
                label: d => SystemText('Admin/CompetencyAreas/Columns/Sort', d.name),
                icon: 'fa-sort-amount-asc',
                onClick: d => {
                    setCompSortArea(d);
                    setShowCompSort(true);
                },
            },
        ],
    };

    const fields = [
        {
            label: SystemText('Admin/CompetencyAreas/Fields/Label/CompetencyArea'),
            type: 'text',
            dataProperty: 'name',
            mandatory: true,
            maxLength: 50,
            generalErrors: true,
            uniqueErrors: true,
            help: SystemText('Admin/CompetencyAreas/Fields/Help/CompetencyArea'),
        },
    ];

    const tableColumns = [
        {
            label: SystemText('Admin/CompetencyAreas/Columns/Label/Sequence'),
            dataProperty: 'sequence',
            format: x => x + 1,
        },
        { label: SystemText('Admin/CompetencyAreas/Columns/Label/Area'), dataProperty: 'name' },
        {
            label: SystemText('Admin/CompetencyAreas/Columns/Label/Competencies'),
            dataProperty: 'competency_Ids',
            showCount: true,
            onClick: item => {
                setPickerItem(item);
                setShowPicker(true);
            },
        },
    ];

    const extraButtons = (
        <button
            className="btn btn-primary"
            onClick={() => {
                setShowSort(true);
            }}
        >
            <i className="fa fa-sort-amount-asc mr10" />
            {SystemText('Admin/CompetencyAreas/Buttons/SortAreas')}
        </button>
    );

    return (
        <div data-testid="admin-competencyareas-wrapper-testid">
            <SimpleAdmin
                {...props}
                data={data}
                add={onAdd}
                load={onLoad}
                update={onUpdate}
                remove={onRemove}
                fields={fields}
                options={options}
                columns={tableColumns}
                extraButtons={extraButtons}
            />
            <Picker
                title={`${SystemText('Admin/CompetencyAreas/Picker/Title')} ${pickerItem?.name}`}
                help={SystemText('Admin/CompetencyAreas/Picker/Help')}
                mandatory
                mandatoryMessage={SystemText('Admin/CompetencyAreas/Picker/Message')}
                entity={SystemText('Admin/CompetencyAreas/Picker/Entity')}
                data={competencies}
                nameProperty="admin_Full_Name"
                value={pickerItem?.competency_Ids}
                show={showPicker}
                onSave={ids => {
                    onUpdate({ ...pickerItem, update_Competency_Ids: ids }, () => {
                        dispatch(setShowSuccess(SystemText('Admin/CompetencyAreas/Success')));
                        setShowPicker(false);
                        onLoad();
                    });
                }}
                onClose={() => {
                    setShowPicker(false);
                    setPickerItem(null);
                }}
                itemPrefix="star"
            />
            {ArrayHelpers.existsAndHasLength(data) && (
                <SortAreas
                    show={showSort}
                    close={() => {
                        setShowSort(false);
                    }}
                    refresh={() => {
                        dispatch(setShowSuccess(SystemText('Admin/CompetencyAreas/OrderSuccess')));
                        onLoad();
                    }}
                    areas={data}
                />
            )}
            {compSortArea && (
                <SortCompetencies
                    show={showCompSort}
                    close={() => {
                        setShowCompSort(false);
                    }}
                    refresh={() => {
                        dispatch(setShowSuccess(SystemText('Admin/CompetencyAreas/OrderSuccess')));
                        onLoad();
                    }}
                    noFilter
                    areaName={compSortArea.name}
                    competencies={competencies.filter(c => c.area_Id === compSortArea.id)}
                />
            )}
        </div>
    );
};

export default AdminCompetencyAreas;
